import {CompanyPill} from 'iq-onboarding/components/company_pill';
import {LevelPillTag} from 'iq-questions/components/level_pilltag';
import {TopicPillTag} from 'iq-questions/components/topic_pilltag';
import type {SummaryQuestion} from 'iq-onboarding/types';

export function QuestionsCard({
  questions,
  totalCount,
}: {
  questions: SummaryQuestion[];
  totalCount: number;
}) {
  return (
    <div className='bg-white rounded-2xl p-5 flex flex-col gap-4 h-full'>
      <div>
        <h2 className='text-lg font-bold text-iq-black'>Practice questions</h2>
        <p className='text-sm text-iq-grey-medium'>
          Real questions asked at the companies you&apos;re targeting.
        </p>
      </div>

      <div className='flex items-baseline gap-2'>
        <span data-testid='summary-questions-count' className='text-3xl font-extrabold text-iq-orange'>
          {totalCount.toLocaleString()}
        </span>
        <span className='text-sm font-semibold text-iq-grey-dark'>questions to practice</span>
      </div>

      <div className='flex flex-col gap-3'>
        {questions.map((q) => (
          <div
            key={q.id}
            data-testid='summary-question-row'
            className='rounded-lg border border-iq-grey-light p-3 flex flex-col gap-2'>
            <h3 className='text-sm font-semibold text-iq-black'>{q.title}</h3>
            {q.summary && (
              <p className='text-xs text-iq-grey-dark line-clamp-2'>{q.summary}</p>
            )}
            <div className='flex flex-wrap items-center gap-2'>
              <TopicPillTag name={q.topic.name} />
              <LevelPillTag level={q.level} />
            </div>
            <div className='flex flex-wrap items-center gap-2'>
              {q.companies.map((c) => (
                <CompanyPill key={c.slug} company={c} />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
